// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-root .hb-select.validation-wrapper {
  position: relative;
  display: inline-block;
  font-size: 1rem;
}
app-root .hb-select.validation-wrapper select {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  display: inline-block;
  font-size: 1rem;
  position: relative;
  color: #1f1f1f;
  background-color: white;
  font-weight: 500;
  height: calc(1.5em + 18px);
  padding: 8px;
  border: 1px solid #595959;
  border-radius: 4px;
  outline: 0;
  will-change: border-color, outline, box-shadow;
  transition-property: border-color, outline, box-shadow;
  transition-timing-function: ease;
  transition-duration: 0.3s;
}
app-root .hb-select.validation-wrapper select:hover {
  border-color: #3e3e3e;
  box-shadow: 0 0 0 2px #dddddd;
}
app-root .hb-select.validation-wrapper select:focus {
  outline: #3e3e3e solid 2px;
  outline-offset: -2px;
  box-shadow: 0 0 0 3px rgba(126, 126, 126, 0.2);
}
app-root .hb-select.validation-wrapper .icon-wrapper {
  position: absolute;
  display: inline-block;
  pointer-events: none;
  width: 1.2em;
  height: 1.2em;
  top: calc(0.75em + 9px);
  transform: translateY(-50%);
  right: 8px;
  color: #595959;
}
app-root .hb-select.validation-wrapper.with-icon select {
  padding-right: calc(1em + 16px);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Form/Inputs/Select/Select.less"],"names":[],"mappings":"AAEA;EAEI,kBAAA;EACA,qBAAA;EACA,eAAA;AAFJ;AAFA;EAOM,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EAEA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EAEA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EAEA,8CAAA;EACA,sDAAA;EACA,gCAAA;EACA,yBAAA;AALN;AAOM;EACE,qBAAA;EACA,6BAAA;AALR;AAQM;EACE,0BAAA;EACA,oBAAA;EACA,8CAAA;AANR;AA/BA;EA0CM,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,UAAA;EACA,cAAA;AARN;AAWI;EAEI,+BAAA;AAVR","sourcesContent":["@import '../../../../Styles/colours.less';\n\napp-root {\n  .hb-select.validation-wrapper {\n    position: relative;\n    display: inline-block;\n    font-size: 1rem;\n\n    select {\n      -moz-appearance: none;\n      -webkit-appearance: none;\n      appearance: none;\n      display: inline-block;\n      font-size: 1rem;\n      position: relative;\n\n      color: @text-black;\n      background-color: white;\n      font-weight: 500;\n      height: calc(1.5em + 18px);\n\n      padding: 8px;\n      border: 1px solid @border-grey;\n      border-radius: 4px;\n      outline: 0;\n\n      will-change: border-color, outline, box-shadow;\n      transition-property: border-color, outline, box-shadow;\n      transition-timing-function: ease;\n      transition-duration: 0.3s;\n\n      &:hover {\n        border-color: @hover-grey;\n        box-shadow: 0 0 0 2px @outline-hover-grey;\n      }\n\n      &:focus {\n        outline: @hover-grey solid 2px;\n        outline-offset: -2px;\n        box-shadow: 0 0 0 3px rgba(126, 126, 126, 0.2);\n      }\n    }\n\n    .icon-wrapper {\n      position: absolute;\n      display: inline-block;\n      pointer-events: none;\n      width: 1.2em;\n      height: 1.2em;\n      top: calc(0.75em + 9px);\n      transform: translateY(-50%);\n      right: 8px;\n      color: @border-grey;\n    }\n\n    &.with-icon {\n      select {\n        padding-right: calc(1em + 16px);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
